var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex theme-sub-chip align-center",
    class: _vm.classSelection
  }, [_c('div', {
    staticClass: "d-flex",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.selectSubSpecialty.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('ph-check-square', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSelected,
      expression: "isSelected"
    }],
    staticClass: "clickable mr-3 secondary--text",
    attrs: {
      "weight": "fill",
      "size": "24"
    }
  }), _c('ph-square', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isSelected,
      expression: "!isSelected"
    }],
    staticClass: "clickable mr-3 grey--text text--lighten-6",
    attrs: {
      "weight": "thin",
      "size": "24"
    }
  })], 1), _c('h6', {
    staticClass: "heading text-l-large-semibold grey--text text--darken-3 text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }